<template>
  <section
    :class="`bg-white ${
      hasBorder ? 'border-b-4' : ''
    }  border-h-primary-500 rounded-lg shadow-sm h-full w-full p-3`"
  >
    <div v-if="!isEmpty" class="flex justify-between items-center py-2">
      <v-icon v-if="!img && icon" :name="icon" />
      <img v-else-if="data.icon" :src="data.icon" alt="card-image" />
      <div class="flex flex-col items-end gap-3">
        <p class="text-xl font-bold">{{ data.title }}</p>
        <p class="text-sm">{{ data.info }}</p>
      </div>
    </div>

    <div v-else>
      <slot name="content"></slot>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "simpleCard",
  props: {
    icon: { type: String, default: "" },
    data: { type: Object, default: new Object() },
    img: { type: Boolean, default: true },
    isEmpty: { type: Boolean, default: false },
    hasBorder: { type: Boolean, default: true },
  },
});
</script>
